import React from 'react';

export type LightboxType = 'image' | 'pdf' | 'video' | 'doc';

export const getFileTypeFromUrl = (url: string): LightboxType => {
  const lowerUrl = url.toLowerCase();
  if (/\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(lowerUrl)) return 'image';
  if (/\.pdf$/i.test(lowerUrl)) return 'pdf';
  if (/\.(mp4|webm|ogg|mov|avi)$/i.test(lowerUrl)) return 'video';
  return 'doc';
};

export const renderUrlPreview = (
  url: string,
  fileName: string,
  label: string,
  openLightbox: (url: string, type?: LightboxType) => void,
): React.ReactNode => {
  const fileType = getFileTypeFromUrl(url);
  const displayName = fileName || url.split('/').pop() || label;

  if (fileType === 'image') {
    return (
      <div className="mt-2">
        <img
          src={url}
          alt={displayName}
          className="max-w-full h-auto max-h-64 rounded cursor-pointer hover:opacity-90 transition-opacity border border-gray-200"
          onClick={() => openLightbox(url, 'image')}
        />
        <p className="text-xs text-gray-500 mt-1">Click image to view in lightbox</p>
      </div>
    );
  } else if (fileType === 'pdf') {
    return (
      <div className="mt-2">
        <iframe src={url} className="w-full h-64 rounded border border-gray-200" title={displayName} />
        <button
          type="button"
          onClick={() => openLightbox(url, 'pdf')}
          className="mt-2 px-2 py-1 text-xs rounded border border-gray-300 bg-white hover:bg-gray-50 text-gray-700"
        >
          Open in Lightbox
        </button>
      </div>
    );
  } else if (fileType === 'video') {
    return (
      <div className="mt-2">
        <video src={url} controls className="max-w-full h-auto max-h-64 rounded border border-gray-200" />
        <button
          type="button"
          onClick={() => openLightbox(url, 'video')}
          className="mt-2 px-2 py-1 text-xs rounded border border-gray-300 bg-white hover:bg-gray-50 text-gray-700"
        >
          Open in Lightbox
        </button>
      </div>
    );
  } else {
    return (
      <div className="mt-2">
        <div
          className="flex items-center gap-2 p-3 bg-gray-100 rounded border border-gray-200 cursor-pointer hover:bg-gray-200 transition-colors"
          onClick={() => openLightbox(url, 'doc')}
        >
          <span className="text-2xl">📄</span>
          <div className="flex-1">
            <div className="font-medium text-sm">{displayName}</div>
            <p className="text-xs text-gray-500 mt-0.5">Click to preview in lightbox</p>
          </div>
        </div>
        <button
          type="button"
          onClick={() => openLightbox(url, 'doc')}
          className="mt-2 px-2 py-1 text-xs rounded border border-gray-300 bg-white hover:bg-gray-50 text-gray-700"
        >
          Open in Lightbox
        </button>
      </div>
    );
  }
};
